import Icons from "../Icons";

export const WarningDialog = ({
  isOpen,
  setIsPreviousOpen,
  onClose,
  onProceed,
}) => {
  if (!isOpen) return null;

  return (
    <div className="font-[Afacad Flux] fixed inset-0 bg-darkblue bg-opacity-65 flex justify-center items-center">
      <div className="bg-background-blackpearl shadow-lg w-3/5 2xl:w-1/2">
        <div className="flex justify-end items-center pl-6 pr-3 pt-3 pb-4 mb-20">
          <button
            onClick={onClose}
            className="text-[#F5EFF7] text-2xl justify-end"
          >
            &times;
          </button>
        </div>
        <div className="p-6 mb-20">
          <div className="flex justify-center mb-4">
            <Icons type="warning" className="text-persimmon" />
          </div>
          <p className="mb-4 text-[24px] font-normal leading-[32px] uppercase text-center text-[#F4F6FB]">
            ARE YOU SURE YOU WANT TO CANCEL?
          </p>
          <p className="text-[11px] font-normal leading-[20px] lowercase text-center text-[#F4F6FB]">
            all the details of the bookmark you started creating will be lost if
            you cancel now.
          </p>
        </div>
        <div className="flex justify-between p-6">
          <button
            type="button"
            onClick={onClose}
            className="flex items-center gap-2 bg-transparent text-persimmon font-medium py-2 px-4 rounded-full text-base leading-5 tracking-wide uppercase border-none border-persimmon"
          >
            <Icons type="leftArrow" />
            GO BACK
          </button>
          <button
            onClick={() => {
              onProceed();
              if (setIsPreviousOpen) {
                setIsPreviousOpen(false);
              }
              onClose();
            }}
            className="text-persimmon font-medium py-2 px-4 rounded-full text-base leading-5 tracking-wide uppercase"
          >
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};
